import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppContext } from '../../../../AppModulesWrapper';
import { selectAnalyticsProduct } from '../../../selectors/analytics';

import { IUseBalanceAnalytics, ITrackNaturalDepositLinkClickAnalyticsExtra } from '../types';

export const useBalanceAnalytics = (): IUseBalanceAnalytics => {
  const { analytics } = useAppContext();

  const product = useSelector(selectAnalyticsProduct);

  const trackNaturalDepositLinkClick = useCallback(() => {
    analytics.send<ITrackNaturalDepositLinkClickAnalyticsExtra>({
      action: 'Click',
      label: 'balance',
      products: [product],
      extra: {
        type: 'fvu_newest',
      },
    });
  }, [analytics, product]);

  const trackLegalDepositLinkClick = useCallback(() => {
    analytics.send({
      action: 'click_pay_lk',
      label: 'balance',
    });
  }, [analytics]);

  return { trackNaturalDepositLinkClick, trackLegalDepositLinkClick };
};
